import { gql } from '@common/hooks';

const OrganizationFragment = gql`
  fragment OrganizationFragment on Organization {
    id
    name
    entityType
    requiresAcceptTermsConditions
    internationalAsDefault
    worksProgramsCount
    onDemandEnabled
    defaultTimeZone
  }
`;

const SupplierFragment = gql`
  fragment SupplierFragment on Supplier {
    id
    name
    entityType
    address
    city
    phoneNumber
    postalCode
    stateCode
    website
    defaultTimeZone
    defaultContact {
      id
      name
    }
  }
`;

export const CurrentEntityContextQuery = gql`
  query CurrentEntityQuery {
    currentEntity {
      __typename

      ... on Organization {
        ...OrganizationFragment
      }

      ... on Supplier {
        ...SupplierFragment
      }
    }
  }
  ${OrganizationFragment}
  ${SupplierFragment}
`;

export type CurrentEntityContextQueryResponse = {
  currentEntity: CurrentEntityType;
};

export type CurrentEntityType = {
  id: string;
  name: string;
  entityType: string;
  address: string;
  city: string;
  defaultTimeZone?: string;
  defaultContact: {
    id: string;
    name: string;
  };
  onDemandEnabled: boolean;
  phoneNumber: string;
  postalCode: string;
  stateCode: string;
  website: string;
  worksProgramsCount?: number;
  internationalAsDefault: boolean;
  requiresAcceptTermsConditions: boolean;
};
